"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ConnectedServer {
    constructor(_userId, _siteId, _siteNamespace, _workbookId) {
        this._userId = _userId;
        this._siteId = _siteId;
        this._siteNamespace = _siteNamespace;
        this._workbookId = _workbookId;
    }
    get userId() {
        return this._userId;
    }
    get siteId() {
        return this._siteId;
    }
    get siteNamespace() {
        return this._siteNamespace;
    }
    get workbookId() {
        return this._workbookId;
    }
}
exports.ConnectedServer = ConnectedServer;
//# sourceMappingURL=ConnectedServer.js.map